// myapp/src/constants/roles.ts

export const ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  COMPANY_ADMIN: 'CompanyAdmin',
  HR_MANAGER: 'HRManager',
  EMPLOYEE: 'Employee',
  INVENTORY_MANAGER: 'InventoryManager',
  DEPARTMENT_MANAGER: 'DepartmentManager',
  SALES_MANAGER: 'SalesManager',
  ACCOUNTANT: 'Accountant',
} as const;

export type UserRole = typeof ROLES[keyof typeof ROLES];
